export default class formConfig {
  // 区管划分
  static configList() {
    return [
      {
        title: "区管部门详情",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "所属区管单位：",
            type: "select",
            value: "zoneCode",
            placeholder: "请输入",
            queryParams: {
              url: "/zoneCode/ZoneCodeCombobox",
            },
            rule: {
              required: true,
              message: "请选择所属区管单位",
              trigger: "blur"
            }
          },
          {
            label: "部门名称：",
            type: "input",
            value: "departmentName",
            placeholder: "请输入",
            maxlength: 100,
            rule: {
              required: true,
              message: "请填写部门名称",
              trigger: "blur"
            }
          },
          {
            label: "部门代码：",
            type: "input",
            value: "departmentCode",
            placeholder: "请输入",
            maxlength: 10,
            rule: {
              required: true,
              message: "请填写部门代码",
              trigger: "blur"
            }
          },
          {
            label: "缴费交易中心：",
            type: "select",
            value: "tradingCenter",
            placeholder: "请输入",
            queryParams: {
              url: "/zoneCode/TradingCenterCombobox",
            },
            rule: {
              required: true,
              message: "请选择缴费交易中心",
              trigger: "blur"
            }
          },
          {
            label: "交易目录：",
            type: "cascader",
            value: "purchaserIds",
            placeholder: "请输入",
            url: "/transactionDirectory/TransactionDirectoryComboTree?editFlg=falseFlag",
            required: true,
            rule: {
              required: false,
              message: "请选择交易目录",
              trigger: "blur"
            },
            clearable: true,
            propsData: {
              value: "id",
              label: "transactionName",
              children: "children",
              multiple: true
            }
          },
          {
            label: "是否废止：",
            type: "select",
            value: "abolishFlag",
            placeholder: "请输入",
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" },
            ],
            rule: {
              required: true,
              message: "请选择是否废止",
              trigger: "blur"
            }
          },
          {
            label: "是否缴费：",
            type: "select",
            value: "isPay",
            placeholder: "请输入",
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" },
            ],
            rule: {
              required: true,
              message: "请选择是否缴费",
              trigger: "blur"
            }
          },
          {
            label: "电话：",
            type: "input",
            value: "phoneNumber",
            placeholder: "请输入",
            maxlength: 30,
            rule: {
              required: false,
              message: "请填写部门代码",
              trigger: "blur"
            }
          },
          {
            label: "传真号码：",
            type: "input",
            value: "fax",
            placeholder: "请输入",
            maxlength: 30,
            rule: {
              required: false,
              message: "请填写传真号码",
              trigger: "blur"
            }
          },
          {
            label: "邮政编码：",
            type: "input",
            value: "postalCode",
            placeholder: "请输入",
            maxlength: 6,
            rule: {
              required: false,
              message: "请填写邮政编码",
              trigger: "blur"
            }
          },
          {
            label: "地址：",
            type: "input",
            value: "address",
            placeholder: "请输入",
            maxlength: 100,
            rule: {
              required: false,
              message: "请填写地址",
              trigger: "blur"
            }
          },
          {
            label: "是否报送监管：",
            type: "select",
            value: "isAudit",
            placeholder: "请输入",
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" },
            ],
            rule: {
              required: true,
              message: "请选择是否报送监管",
              trigger: "blur"
            }
          },
          {
            label: "行政区划：",
            type: "select",
            value: "areaCode",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/AreaCodeDataCombobox",
              flag: "0"
            },
            rule: {
              required: true,
              message: "请选择行政区划",
              trigger: "blur"
            }
          },
        ]
      },
    ];
  }
}
